(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './curity-ssi-libs-core-json.js', './kotlin-kotlin-stdlib.js', './curity-ssi-libs-core.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlinx-serialization-kotlinx-serialization-json.js', './Kotlin-DateTime-library-kotlinx-datetime.js', './curity-ssi-libs-did.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./curity-ssi-libs-core-json.js'), require('./kotlin-kotlin-stdlib.js'), require('./curity-ssi-libs-core.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./Kotlin-DateTime-library-kotlinx-datetime.js'), require('./curity-ssi-libs-did.js'));
  else {
    if (typeof this['curity-ssi-libs-core-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-json'. Its dependency 'curity-ssi-libs-core-json' was not found. Please, check whether 'curity-ssi-libs-core-json' is loaded prior to 'curity-ssi-libs-did-json'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-json'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'curity-ssi-libs-did-json'.");
    }
    if (typeof this['curity-ssi-libs-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-json'. Its dependency 'curity-ssi-libs-core' was not found. Please, check whether 'curity-ssi-libs-core' is loaded prior to 'curity-ssi-libs-did-json'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-json'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'curity-ssi-libs-did-json'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-json'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'curity-ssi-libs-did-json'.");
    }
    if (typeof this['Kotlin-DateTime-library-kotlinx-datetime'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-json'. Its dependency 'Kotlin-DateTime-library-kotlinx-datetime' was not found. Please, check whether 'Kotlin-DateTime-library-kotlinx-datetime' is loaded prior to 'curity-ssi-libs-did-json'.");
    }
    if (typeof this['curity-ssi-libs-did'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did-json'. Its dependency 'curity-ssi-libs-did' was not found. Please, check whether 'curity-ssi-libs-did' is loaded prior to 'curity-ssi-libs-did-json'.");
    }
    root['curity-ssi-libs-did-json'] = factory(typeof this['curity-ssi-libs-did-json'] === 'undefined' ? {} : this['curity-ssi-libs-did-json'], this['curity-ssi-libs-core-json'], this['kotlin-kotlin-stdlib'], this['curity-ssi-libs-core'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlinx-serialization-kotlinx-serialization-json'], this['Kotlin-DateTime-library-kotlinx-datetime'], this['curity-ssi-libs-did']);
  }
}(globalThis, function (_, kotlin_io_curity_ssi_core_json, kotlin_kotlin, kotlin_io_curity_ssi_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_datetime, kotlin_io_curity_ssi_did) {
  'use strict';
  //region block: imports
  var FromJsonHelper_instance = kotlin_io_curity_ssi_core_json.$_$.g;
  var toMap = kotlin_kotlin.$_$.m8;
  var protoOf = kotlin_kotlin.$_$.kb;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
  var JsonDictionary = kotlin_io_curity_ssi_core_json.$_$.o;
  var get_keys = kotlin_io_curity_ssi_core_json.$_$.r;
  var get = kotlin_io_curity_ssi_core_json.$_$.q;
  var toMap_0 = kotlin_io_curity_ssi_core.$_$.d;
  var toJson = kotlin_io_curity_ssi_core_json.$_$.s;
  var Dictionary = kotlin_io_curity_ssi_core.$_$.e;
  var ToJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.t;
  var initMetadataForClass = kotlin_kotlin.$_$.ia;
  var VOID = kotlin_kotlin.$_$.f;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var Unit_instance = kotlin_kotlin.$_$.h5;
  var THROW_CCE = kotlin_kotlin.$_$.te;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var initMetadataForObject = kotlin_kotlin.$_$.oa;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.jb;
  var MultiValue = kotlin_io_curity_ssi_core.$_$.l;
  var getKClass = kotlin_kotlin.$_$.e;
  var PolymorphicSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var DefaultJsonMultiValueSerializer_getInstance = kotlin_io_curity_ssi_core_json.$_$.f;
  var lazy = kotlin_kotlin.$_$.qf;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var get_jsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.s;
  var ToString = kotlin_io_curity_ssi_core.$_$.m;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var toMutableMap = kotlin_kotlin.$_$.p8;
  var unwrapOptionalStringInstant = kotlin_io_curity_ssi_core_json.$_$.k1;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
  var Companion_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.c;
  var unwrapOptionalString = kotlin_io_curity_ssi_core_json.$_$.m1;
  var AnyString = kotlin_io_curity_ssi_core_json.$_$.j;
  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
  var emptyMap = kotlin_kotlin.$_$.s6;
  var KProperty1 = kotlin_kotlin.$_$.ac;
  var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var DidUrl = kotlin_io_curity_ssi_did.$_$.e;
  var Companion_getInstance_0 = kotlin_io_curity_ssi_did.$_$.b;
  var toString = kotlin_kotlin.$_$.ob;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var JsonSerializer = kotlin_io_curity_ssi_core_json.$_$.p;
  var Did = kotlin_io_curity_ssi_did.$_$.f;
  var Companion_instance = kotlin_io_curity_ssi_did.$_$.a;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForClass(JsonPublicKeyJwk, 'JsonPublicKeyJwk', VOID, VOID, [Dictionary, ToJsonDictionary], VOID, VOID, {0: JsonPublicKeyJwkSerializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonDidResolutionSuccessResult, 'JsonDidResolutionSuccessResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForCompanion(Companion_1);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonDidDocument, 'JsonDidDocument', VOID, VOID, [Dictionary, ToJsonDictionary], VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForCompanion(Companion_2);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonVerificationMethod, 'JsonVerificationMethod', VOID, VOID, [ToJsonDictionary], VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(JsonDidDocumentMetadata, 'JsonDidDocumentMetadata', VOID, VOID, [Dictionary, ToJsonDictionary], VOID, VOID, {0: JsonDidDocumentMetadataSerializer_getInstance});
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(JsonDidResolutionMetadata, 'JsonDidResolutionMetadata', JsonDidResolutionMetadata, VOID, [Dictionary, ToJsonDictionary], VOID, VOID, {0: JsonDidResolutionMetadataSerializer_getInstance});
  initMetadataForObject(DidUrlAsStringSerializer, 'DidUrlAsStringSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonPublicKeyJwkSerializer, 'JsonPublicKeyJwkSerializer', VOID, JsonSerializer);
  initMetadataForObject(DidAsStringSerializer, 'DidAsStringSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonDidDocumentMetadataSerializer, 'JsonDidDocumentMetadataSerializer', VOID, JsonSerializer);
  initMetadataForObject(JsonDidResolutionMetadataSerializer, 'JsonDidResolutionMetadataSerializer', VOID, JsonSerializer);
  //endregion
  function Companion() {
  }
  protoOf(Companion).d27 = function (json) {
    return new JsonPublicKeyJwk(toMap(FromJsonHelper_instance.b27(json, 'PublicKeyJwk')));
  };
  protoOf(Companion).a3k = function (other) {
    var tmp;
    if (other instanceof JsonPublicKeyJwk) {
      tmp = other;
    } else {
      tmp = new JsonPublicKeyJwk(other.xl());
    }
    return tmp;
  };
  var Companion_instance_0;
  function Companion_getInstance_1() {
    return Companion_instance_0;
  }
  function JsonPublicKeyJwk(map) {
    this.b3k_1 = map;
  }
  protoOf(JsonPublicKeyJwk).y26 = function () {
    return new JsonDictionary(this.b3k_1);
  };
  function Companion_0() {
  }
  var Companion_instance_1;
  function Companion_getInstance_2() {
    return Companion_instance_1;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.ssi.did.json.JsonDidResolutionSuccessResult', this, 3);
    tmp0_serialDesc.wy('document', false);
    tmp0_serialDesc.wy('documentMetadata', true);
    tmp0_serialDesc.wy('resolutionMetadata', true);
    this.c3k_1 = tmp0_serialDesc;
  }
  protoOf($serializer).d3k = function (encoder, value) {
    var tmp0_desc = this.c3k_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance_0(), value.e3k_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.f3k_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, JsonDidDocumentMetadataSerializer_getInstance(), value.f3k_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.g3k_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, JsonDidResolutionMetadataSerializer_getInstance(), value.g3k_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer).zn = function (encoder, value) {
    return this.d3k(encoder, value instanceof JsonDidResolutionSuccessResult ? value : THROW_CCE());
  };
  protoOf($serializer).ao = function (decoder) {
    var tmp0_desc = this.c3k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, JsonDidDocumentMetadataSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, JsonDidResolutionMetadataSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, JsonDidDocumentMetadataSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, JsonDidResolutionMetadataSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JsonDidResolutionSuccessResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer).yn = function () {
    return this.c3k_1;
  };
  protoOf($serializer).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_0(), get_nullable(JsonDidDocumentMetadataSerializer_getInstance()), get_nullable(JsonDidResolutionMetadataSerializer_getInstance())];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function JsonDidResolutionSuccessResult_init_$Init$(seen0, document, documentMetadata, resolutionMetadata, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance().c3k_1);
    }
    $this.e3k_1 = document;
    if (0 === (seen0 & 2))
      $this.f3k_1 = null;
    else
      $this.f3k_1 = documentMetadata;
    if (0 === (seen0 & 4))
      $this.g3k_1 = null;
    else
      $this.g3k_1 = resolutionMetadata;
    return $this;
  }
  function JsonDidResolutionSuccessResult_init_$Create$(seen0, document, documentMetadata, resolutionMetadata, serializationConstructorMarker) {
    return JsonDidResolutionSuccessResult_init_$Init$(seen0, document, documentMetadata, resolutionMetadata, serializationConstructorMarker, objectCreate(protoOf(JsonDidResolutionSuccessResult)));
  }
  function JsonDidResolutionSuccessResult(document, documentMetadata, resolutionMetadata) {
    documentMetadata = documentMetadata === VOID ? null : documentMetadata;
    resolutionMetadata = resolutionMetadata === VOID ? null : resolutionMetadata;
    this.e3k_1 = document;
    this.f3k_1 = documentMetadata;
    this.g3k_1 = resolutionMetadata;
  }
  protoOf(JsonDidResolutionSuccessResult).h3k = function () {
    return this.e3k_1;
  };
  function Companion_1() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = getKClass(MultiValue);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i3k_1 = [null, PolymorphicSerializer_init_$Create$(tmp_0, tmp$ret$2), null, null, null, null, null, null, null, null];
  }
  protoOf(Companion_1).b1b = function () {
    return $serializer_getInstance_0();
  };
  var Companion_instance_2;
  function Companion_getInstance_3() {
    if (Companion_instance_2 == null)
      new Companion_1();
    return Companion_instance_2;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.ssi.did.json.JsonDidDocument', this, 10);
    tmp0_serialDesc.wy('id', false);
    tmp0_serialDesc.wy('verificationMethod', false);
    tmp0_serialDesc.wy('alsoKnownAs', true);
    tmp0_serialDesc.wy('controller', true);
    tmp0_serialDesc.wy('authentication', true);
    tmp0_serialDesc.wy('assertionMethod', true);
    tmp0_serialDesc.wy('keyAgreement', true);
    tmp0_serialDesc.wy('capabilityInvocation', true);
    tmp0_serialDesc.wy('capabilityDelegation', true);
    tmp0_serialDesc.wy('service', true);
    this.j3k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).k3k = function (encoder, value) {
    var tmp0_desc = this.j3k_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_3().i3k_1;
    tmp1_output.bt(tmp0_desc, 0, DidAsStringSerializer_getInstance(), value.l3k_1);
    tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.m3k_1);
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.n3k_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, DefaultJsonMultiValueSerializer_getInstance(), value.n3k_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.o3k_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, DefaultJsonMultiValueSerializer_getInstance(), value.o3k_1);
    }
    if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.p3k_1 == null)) {
      tmp1_output.dt(tmp0_desc, 4, DefaultJsonMultiValueSerializer_getInstance(), value.p3k_1);
    }
    if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.q3k_1 == null)) {
      tmp1_output.dt(tmp0_desc, 5, DefaultJsonMultiValueSerializer_getInstance(), value.q3k_1);
    }
    if (tmp1_output.ht(tmp0_desc, 6) ? true : !(value.r3k_1 == null)) {
      tmp1_output.dt(tmp0_desc, 6, DefaultJsonMultiValueSerializer_getInstance(), value.r3k_1);
    }
    if (tmp1_output.ht(tmp0_desc, 7) ? true : !(value.s3k_1 == null)) {
      tmp1_output.dt(tmp0_desc, 7, DefaultJsonMultiValueSerializer_getInstance(), value.s3k_1);
    }
    if (tmp1_output.ht(tmp0_desc, 8) ? true : !(value.t3k_1 == null)) {
      tmp1_output.dt(tmp0_desc, 8, DefaultJsonMultiValueSerializer_getInstance(), value.t3k_1);
    }
    if (tmp1_output.ht(tmp0_desc, 9) ? true : !(value.u3k_1 == null)) {
      tmp1_output.dt(tmp0_desc, 9, DefaultJsonMultiValueSerializer_getInstance(), value.u3k_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_0).zn = function (encoder, value) {
    return this.k3k(encoder, value instanceof JsonDidDocument ? value : THROW_CCE());
  };
  protoOf($serializer_0).ao = function (decoder) {
    var tmp0_desc = this.j3k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp19_input = decoder.lr(tmp0_desc);
    var tmp20_cached = Companion_getInstance_3().i3k_1;
    if (tmp19_input.as()) {
      tmp4_local0 = tmp19_input.xr(tmp0_desc, 0, DidAsStringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp19_input.xr(tmp0_desc, 1, tmp20_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp19_input.zr(tmp0_desc, 2, DefaultJsonMultiValueSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp19_input.zr(tmp0_desc, 3, DefaultJsonMultiValueSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp19_input.zr(tmp0_desc, 4, DefaultJsonMultiValueSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp19_input.zr(tmp0_desc, 5, DefaultJsonMultiValueSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp19_input.zr(tmp0_desc, 6, DefaultJsonMultiValueSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp19_input.zr(tmp0_desc, 7, DefaultJsonMultiValueSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp19_input.zr(tmp0_desc, 8, DefaultJsonMultiValueSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp19_input.zr(tmp0_desc, 9, DefaultJsonMultiValueSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp19_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp19_input.xr(tmp0_desc, 0, DidAsStringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp19_input.xr(tmp0_desc, 1, tmp20_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp19_input.zr(tmp0_desc, 2, DefaultJsonMultiValueSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp19_input.zr(tmp0_desc, 3, DefaultJsonMultiValueSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp19_input.zr(tmp0_desc, 4, DefaultJsonMultiValueSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp19_input.zr(tmp0_desc, 5, DefaultJsonMultiValueSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp19_input.zr(tmp0_desc, 6, DefaultJsonMultiValueSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp19_input.zr(tmp0_desc, 7, DefaultJsonMultiValueSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp19_input.zr(tmp0_desc, 8, DefaultJsonMultiValueSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp19_input.zr(tmp0_desc, 9, DefaultJsonMultiValueSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp19_input.mr(tmp0_desc);
    return JsonDidDocument_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_0).yn = function () {
    return this.j3k_1;
  };
  protoOf($serializer_0).lz = function () {
    var tmp0_cached = Companion_getInstance_3().i3k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DidAsStringSerializer_getInstance(), tmp0_cached[1], get_nullable(DefaultJsonMultiValueSerializer_getInstance()), get_nullable(DefaultJsonMultiValueSerializer_getInstance()), get_nullable(DefaultJsonMultiValueSerializer_getInstance()), get_nullable(DefaultJsonMultiValueSerializer_getInstance()), get_nullable(DefaultJsonMultiValueSerializer_getInstance()), get_nullable(DefaultJsonMultiValueSerializer_getInstance()), get_nullable(DefaultJsonMultiValueSerializer_getInstance()), get_nullable(DefaultJsonMultiValueSerializer_getInstance())];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function JsonDidDocument_init_$Init$(seen0, id, verificationMethod, alsoKnownAs, controller, _authentication, _assertionMethod, _keyAgreement, _capabilityInvocation, _capabilityDelegation, service, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_0().j3k_1);
    }
    $this.l3k_1 = id;
    $this.m3k_1 = verificationMethod;
    if (0 === (seen0 & 4))
      $this.n3k_1 = null;
    else
      $this.n3k_1 = alsoKnownAs;
    if (0 === (seen0 & 8))
      $this.o3k_1 = null;
    else
      $this.o3k_1 = controller;
    if (0 === (seen0 & 16))
      $this.p3k_1 = null;
    else
      $this.p3k_1 = _authentication;
    if (0 === (seen0 & 32))
      $this.q3k_1 = null;
    else
      $this.q3k_1 = _assertionMethod;
    if (0 === (seen0 & 64))
      $this.r3k_1 = null;
    else
      $this.r3k_1 = _keyAgreement;
    if (0 === (seen0 & 128))
      $this.s3k_1 = null;
    else
      $this.s3k_1 = _capabilityInvocation;
    if (0 === (seen0 & 256))
      $this.t3k_1 = null;
    else
      $this.t3k_1 = _capabilityDelegation;
    if (0 === (seen0 & 512))
      $this.u3k_1 = null;
    else
      $this.u3k_1 = service;
    var tmp = $this;
    tmp.v3k_1 = lazy(JsonDidDocument$_init_$lambda_nmzsrd($this));
    var tmp_0 = $this;
    tmp_0.w3k_1 = lazy(JsonDidDocument$_init_$lambda_nmzsrd_0($this));
    var tmp_1 = $this;
    tmp_1.x3k_1 = lazy(JsonDidDocument$_init_$lambda_nmzsrd_1($this));
    var tmp_2 = $this;
    tmp_2.y3k_1 = lazy(JsonDidDocument$_init_$lambda_nmzsrd_2($this));
    var tmp_3 = $this;
    tmp_3.z3k_1 = lazy(JsonDidDocument$_init_$lambda_nmzsrd_3($this));
    return $this;
  }
  function JsonDidDocument_init_$Create$(seen0, id, verificationMethod, alsoKnownAs, controller, _authentication, _assertionMethod, _keyAgreement, _capabilityInvocation, _capabilityDelegation, service, serializationConstructorMarker) {
    return JsonDidDocument_init_$Init$(seen0, id, verificationMethod, alsoKnownAs, controller, _authentication, _assertionMethod, _keyAgreement, _capabilityInvocation, _capabilityDelegation, service, serializationConstructorMarker, objectCreate(protoOf(JsonDidDocument)));
  }
  function JsonDidDocument$authentication$delegate$lambda$lambda(it) {
    return it.a3l();
  }
  function JsonDidDocument$authentication$delegate$lambda(this$0) {
    return function () {
      var tmp4_safe_receiver = this$0.p3k_1;
      var tmp;
      if (tmp4_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp4_safe_receiver.k27(JsonDidDocument$authentication$delegate$lambda$lambda);
      }
      return tmp;
    };
  }
  function JsonDidDocument$assertionMethod$delegate$lambda$lambda(it) {
    return it.a3l();
  }
  function JsonDidDocument$assertionMethod$delegate$lambda(this$0) {
    return function () {
      var tmp5_safe_receiver = this$0.q3k_1;
      var tmp;
      if (tmp5_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp5_safe_receiver.k27(JsonDidDocument$assertionMethod$delegate$lambda$lambda);
      }
      return tmp;
    };
  }
  function JsonDidDocument$keyAgreement$delegate$lambda$lambda(it) {
    return it.a3l();
  }
  function JsonDidDocument$keyAgreement$delegate$lambda(this$0) {
    return function () {
      var tmp6_safe_receiver = this$0.r3k_1;
      var tmp;
      if (tmp6_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp6_safe_receiver.k27(JsonDidDocument$keyAgreement$delegate$lambda$lambda);
      }
      return tmp;
    };
  }
  function JsonDidDocument$capabilityInvocation$delegate$lambda$lambda(it) {
    return it.a3l();
  }
  function JsonDidDocument$capabilityInvocation$delegate$lambda(this$0) {
    return function () {
      var tmp7_safe_receiver = this$0.s3k_1;
      var tmp;
      if (tmp7_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp7_safe_receiver.k27(JsonDidDocument$capabilityInvocation$delegate$lambda$lambda);
      }
      return tmp;
    };
  }
  function JsonDidDocument$capabilityDelegation$delegate$lambda$lambda(it) {
    return it.a3l();
  }
  function JsonDidDocument$capabilityDelegation$delegate$lambda(this$0) {
    return function () {
      var tmp8_safe_receiver = this$0.t3k_1;
      var tmp;
      if (tmp8_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp8_safe_receiver.k27(JsonDidDocument$capabilityDelegation$delegate$lambda$lambda);
      }
      return tmp;
    };
  }
  function JsonDidDocument$_init_$lambda$lambda_3wo04c(it) {
    return it.a3l();
  }
  function JsonDidDocument$_init_$lambda_nmzsrd(this$0) {
    return function () {
      var tmp4_safe_receiver = this$0.p3k_1;
      var tmp;
      if (tmp4_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp4_safe_receiver.k27(JsonDidDocument$_init_$lambda$lambda_3wo04c);
      }
      return tmp;
    };
  }
  function JsonDidDocument$_init_$lambda$lambda_3wo04c_0(it) {
    return it.a3l();
  }
  function JsonDidDocument$_init_$lambda_nmzsrd_0(this$0) {
    return function () {
      var tmp5_safe_receiver = this$0.q3k_1;
      var tmp;
      if (tmp5_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp5_safe_receiver.k27(JsonDidDocument$_init_$lambda$lambda_3wo04c_0);
      }
      return tmp;
    };
  }
  function JsonDidDocument$_init_$lambda$lambda_3wo04c_1(it) {
    return it.a3l();
  }
  function JsonDidDocument$_init_$lambda_nmzsrd_1(this$0) {
    return function () {
      var tmp6_safe_receiver = this$0.r3k_1;
      var tmp;
      if (tmp6_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp6_safe_receiver.k27(JsonDidDocument$_init_$lambda$lambda_3wo04c_1);
      }
      return tmp;
    };
  }
  function JsonDidDocument$_init_$lambda$lambda_3wo04c_2(it) {
    return it.a3l();
  }
  function JsonDidDocument$_init_$lambda_nmzsrd_2(this$0) {
    return function () {
      var tmp7_safe_receiver = this$0.s3k_1;
      var tmp;
      if (tmp7_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp7_safe_receiver.k27(JsonDidDocument$_init_$lambda$lambda_3wo04c_2);
      }
      return tmp;
    };
  }
  function JsonDidDocument$_init_$lambda$lambda_3wo04c_3(it) {
    return it.a3l();
  }
  function JsonDidDocument$_init_$lambda_nmzsrd_3(this$0) {
    return function () {
      var tmp8_safe_receiver = this$0.t3k_1;
      var tmp;
      if (tmp8_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp8_safe_receiver.k27(JsonDidDocument$_init_$lambda$lambda_3wo04c_3);
      }
      return tmp;
    };
  }
  function JsonDidDocument(id, verificationMethod, alsoKnownAs, controller, _authentication, _assertionMethod, _keyAgreement, _capabilityInvocation, _capabilityDelegation, service) {
    Companion_getInstance_3();
    alsoKnownAs = alsoKnownAs === VOID ? null : alsoKnownAs;
    controller = controller === VOID ? null : controller;
    _authentication = _authentication === VOID ? null : _authentication;
    _assertionMethod = _assertionMethod === VOID ? null : _assertionMethod;
    _keyAgreement = _keyAgreement === VOID ? null : _keyAgreement;
    _capabilityInvocation = _capabilityInvocation === VOID ? null : _capabilityInvocation;
    _capabilityDelegation = _capabilityDelegation === VOID ? null : _capabilityDelegation;
    service = service === VOID ? null : service;
    this.l3k_1 = id;
    this.m3k_1 = verificationMethod;
    this.n3k_1 = alsoKnownAs;
    this.o3k_1 = controller;
    this.p3k_1 = _authentication;
    this.q3k_1 = _assertionMethod;
    this.r3k_1 = _keyAgreement;
    this.s3k_1 = _capabilityInvocation;
    this.t3k_1 = _capabilityDelegation;
    this.u3k_1 = service;
    var tmp = this;
    tmp.v3k_1 = lazy(JsonDidDocument$authentication$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.w3k_1 = lazy(JsonDidDocument$assertionMethod$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.x3k_1 = lazy(JsonDidDocument$keyAgreement$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.y3k_1 = lazy(JsonDidDocument$capabilityInvocation$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.z3k_1 = lazy(JsonDidDocument$capabilityDelegation$delegate$lambda(this));
  }
  protoOf(JsonDidDocument).y26 = function () {
    return new JsonDictionary(get_jsonObject(Default_getInstance().a19(Companion_getInstance_3().b1b(), this)));
  };
  protoOf(JsonDidDocument).b3l = function (didUrl) {
    var didString = didUrl.toString();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.m3k_1.qm().j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'io.curity.ssi.did.json.JsonDidDocument.getVerificationMethodFor.<anonymous>' call
        if (element.c3l_1.toString() === didString) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  function Companion_2() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = getKClass(ToString);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h3l_1 = [null, null, PolymorphicSerializer_init_$Create$(tmp_0, tmp$ret$2), null, null];
  }
  protoOf(Companion_2).d27 = function (json) {
    return Default_getInstance().b19(this.b1b(), json);
  };
  protoOf(Companion_2).b1b = function () {
    return $serializer_getInstance_1();
  };
  var Companion_instance_3;
  function Companion_getInstance_4() {
    if (Companion_instance_3 == null)
      new Companion_2();
    return Companion_instance_3;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.ssi.did.json.JsonVerificationMethod', this, 5);
    tmp0_serialDesc.wy('id', false);
    tmp0_serialDesc.wy('controller', true);
    tmp0_serialDesc.wy('type', false);
    tmp0_serialDesc.wy('publicKeyJwk', true);
    tmp0_serialDesc.wy('publicKeyMultibase', true);
    this.i3l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).j3l = function (encoder, value) {
    var tmp0_desc = this.i3l_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_4().h3l_1;
    tmp1_output.bt(tmp0_desc, 0, DidUrlAsStringSerializer_getInstance(), value.c3l_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.d3l_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, DefaultJsonMultiValueSerializer_getInstance(), value.d3l_1);
    }
    tmp1_output.bt(tmp0_desc, 2, tmp2_cached[2], value.e3l_1);
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.f3l_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, JsonPublicKeyJwkSerializer_getInstance(), value.f3l_1);
    }
    if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.g3l_1 == null)) {
      tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.g3l_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_1).zn = function (encoder, value) {
    return this.j3l(encoder, value instanceof JsonVerificationMethod ? value : THROW_CCE());
  };
  protoOf($serializer_1).ao = function (decoder) {
    var tmp0_desc = this.i3l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.lr(tmp0_desc);
    var tmp10_cached = Companion_getInstance_4().h3l_1;
    if (tmp9_input.as()) {
      tmp4_local0 = tmp9_input.xr(tmp0_desc, 0, DidUrlAsStringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, DefaultJsonMultiValueSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, JsonPublicKeyJwkSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.xr(tmp0_desc, 0, DidUrlAsStringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, DefaultJsonMultiValueSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, JsonPublicKeyJwkSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.mr(tmp0_desc);
    return JsonVerificationMethod_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_1).yn = function () {
    return this.i3l_1;
  };
  protoOf($serializer_1).lz = function () {
    var tmp0_cached = Companion_getInstance_4().h3l_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DidUrlAsStringSerializer_getInstance(), get_nullable(DefaultJsonMultiValueSerializer_getInstance()), tmp0_cached[2], get_nullable(JsonPublicKeyJwkSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function JsonVerificationMethod_init_$Init$(seen0, id, controller, type, publicKeyJwk, publicKeyMultibase, serializationConstructorMarker, $this) {
    if (!(5 === (5 & seen0))) {
      throwMissingFieldException(seen0, 5, $serializer_getInstance_1().i3l_1);
    }
    $this.c3l_1 = id;
    if (0 === (seen0 & 2))
      $this.d3l_1 = null;
    else
      $this.d3l_1 = controller;
    $this.e3l_1 = type;
    if (0 === (seen0 & 8))
      $this.f3l_1 = null;
    else
      $this.f3l_1 = publicKeyJwk;
    if (0 === (seen0 & 16))
      $this.g3l_1 = null;
    else
      $this.g3l_1 = publicKeyMultibase;
    return $this;
  }
  function JsonVerificationMethod_init_$Create$(seen0, id, controller, type, publicKeyJwk, publicKeyMultibase, serializationConstructorMarker) {
    return JsonVerificationMethod_init_$Init$(seen0, id, controller, type, publicKeyJwk, publicKeyMultibase, serializationConstructorMarker, objectCreate(protoOf(JsonVerificationMethod)));
  }
  function JsonVerificationMethod(id, controller, type, publicKeyJwk, publicKeyMultibase) {
    Companion_getInstance_4();
    controller = controller === VOID ? null : controller;
    publicKeyJwk = publicKeyJwk === VOID ? null : publicKeyJwk;
    publicKeyMultibase = publicKeyMultibase === VOID ? null : publicKeyMultibase;
    this.c3l_1 = id;
    this.d3l_1 = controller;
    this.e3l_1 = type;
    this.f3l_1 = publicKeyJwk;
    this.g3l_1 = publicKeyMultibase;
  }
  protoOf(JsonVerificationMethod).k3l = function () {
    return this.f3l_1;
  };
  protoOf(JsonVerificationMethod).y26 = function () {
    return new JsonDictionary(get_jsonObject(Default_getInstance().a19(Companion_getInstance_4().b1b(), this)));
  };
  function Companion_3() {
  }
  protoOf(Companion_3).d27 = function (json) {
    var obj = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonDidDocumentMetadata'));
    return new JsonDidDocumentMetadata(unwrapOptionalStringInstant(obj, 'updated'), unwrapOptionalStringInstant(obj, 'updated'), toMap(obj));
  };
  var Companion_instance_4;
  function Companion_getInstance_5() {
    return Companion_instance_4;
  }
  function _get__serialized__5dtwz6($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.o3l_1;
    _serialized$factory();
    return this_0.b1();
  }
  function JsonDidDocumentMetadata$_serialized$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.did.json.JsonDidDocumentMetadata._serialized$delegate.<anonymous>.<anonymous>' call
      this_0.o2(this$0.n3l_1);
      var tmp0_safe_receiver = this$0.l3l_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.did.json.JsonDidDocumentMetadata._serialized$delegate.<anonymous>.<anonymous>.<anonymous>' call
        this_0.m2('created', Default_getInstance().a19(Companion_getInstance().b1b(), tmp0_safe_receiver));
      }
      var tmp1_safe_receiver = this$0.m3l_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this_0.m2('updated', Default_getInstance().a19(Companion_getInstance().b1b(), tmp1_safe_receiver));
      }
      var tmp$ret$5 = this_0.r8();
      return new JsonDictionary(tmp$ret$5);
    };
  }
  function JsonDidDocumentMetadata(created, updated, customClaims) {
    created = created === VOID ? null : created;
    updated = updated === VOID ? null : updated;
    this.l3l_1 = created;
    this.m3l_1 = updated;
    this.n3l_1 = customClaims;
    var tmp = this;
    tmp.o3l_1 = lazy(JsonDidDocumentMetadata$_serialized$delegate$lambda(this));
  }
  protoOf(JsonDidDocumentMetadata).y26 = function () {
    return _get__serialized__5dtwz6(this);
  };
  function Companion_4() {
  }
  protoOf(Companion_4).d27 = function (json) {
    var obj = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonDidDocumentMetadata'));
    var tmp2_safe_receiver = unwrapOptionalString(obj, 'contentType');
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.did.json.Companion.fromJson.<anonymous>' call
      tmp = new AnyString(tmp2_safe_receiver);
    }
    return new JsonDidResolutionMetadata(tmp, toMap(obj));
  };
  var Companion_instance_5;
  function Companion_getInstance_6() {
    return Companion_instance_5;
  }
  function _get__serialized__5dtwz6_0($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.r3l_1;
    _serialized$factory_0();
    return this_0.b1();
  }
  function JsonDidResolutionMetadata$_serialized$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.did.json.JsonDidResolutionMetadata._serialized$delegate.<anonymous>.<anonymous>' call
      this_0.o2(this$0.q3l_1);
      var tmp3_safe_receiver = this$0.p3l_1;
      if (tmp3_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this_0.m2('contentType', JsonPrimitive(tmp3_safe_receiver.toString()));
      }
      var tmp$ret$3 = this_0.r8();
      return new JsonDictionary(tmp$ret$3);
    };
  }
  function JsonDidResolutionMetadata(contentType, customClaims) {
    contentType = contentType === VOID ? null : contentType;
    customClaims = customClaims === VOID ? emptyMap() : customClaims;
    this.p3l_1 = contentType;
    this.q3l_1 = customClaims;
    var tmp = this;
    tmp.r3l_1 = lazy(JsonDidResolutionMetadata$_serialized$delegate$lambda(this));
  }
  protoOf(JsonDidResolutionMetadata).y26 = function () {
    return _get__serialized__5dtwz6_0(this);
  };
  function _serialized$factory() {
    return getPropertyCallableRef('_serialized', 1, KProperty1, function (receiver) {
      return _get__serialized__5dtwz6(receiver);
    }, null);
  }
  function _serialized$factory_0() {
    return getPropertyCallableRef('_serialized', 1, KProperty1, function (receiver) {
      return _get__serialized__5dtwz6_0(receiver);
    }, null);
  }
  function DidUrlAsStringSerializer() {
    DidUrlAsStringSerializer_instance = this;
    this.s3l_1 = PrimitiveSerialDescriptor('io.curity.ssi.did.json.DidUrlAsStringSerializer', STRING_getInstance());
  }
  protoOf(DidUrlAsStringSerializer).yn = function () {
    return this.s3l_1;
  };
  protoOf(DidUrlAsStringSerializer).t3l = function (encoder, value) {
    return encoder.os(value.toString());
  };
  protoOf(DidUrlAsStringSerializer).zn = function (encoder, value) {
    return this.t3l(encoder, value instanceof DidUrl ? value : THROW_CCE());
  };
  protoOf(DidUrlAsStringSerializer).ao = function (decoder) {
    var tmp0_elvis_lhs = Companion_getInstance_0().d2i(decoder.gr());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'String does not conform to DID URL syntax';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var DidUrlAsStringSerializer_instance;
  function DidUrlAsStringSerializer_getInstance() {
    if (DidUrlAsStringSerializer_instance == null)
      new DidUrlAsStringSerializer();
    return DidUrlAsStringSerializer_instance;
  }
  function JsonPublicKeyJwkSerializer() {
    JsonPublicKeyJwkSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_0);
  }
  var JsonPublicKeyJwkSerializer_instance;
  function JsonPublicKeyJwkSerializer_getInstance() {
    if (JsonPublicKeyJwkSerializer_instance == null)
      new JsonPublicKeyJwkSerializer();
    return JsonPublicKeyJwkSerializer_instance;
  }
  function DidAsStringSerializer() {
    DidAsStringSerializer_instance = this;
    this.u3l_1 = PrimitiveSerialDescriptor('io.curity.ssi.did.json.DidAsStringSerializer', STRING_getInstance());
  }
  protoOf(DidAsStringSerializer).yn = function () {
    return this.u3l_1;
  };
  protoOf(DidAsStringSerializer).v3l = function (encoder, value) {
    return encoder.os(value.toString());
  };
  protoOf(DidAsStringSerializer).zn = function (encoder, value) {
    return this.v3l(encoder, value instanceof Did ? value : THROW_CCE());
  };
  protoOf(DidAsStringSerializer).ao = function (decoder) {
    var tmp0_elvis_lhs = Companion_instance.a1m(decoder.gr());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'String does not conform to DID syntax';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var DidAsStringSerializer_instance;
  function DidAsStringSerializer_getInstance() {
    if (DidAsStringSerializer_instance == null)
      new DidAsStringSerializer();
    return DidAsStringSerializer_instance;
  }
  function JsonDidDocumentMetadataSerializer() {
    JsonDidDocumentMetadataSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_4);
  }
  var JsonDidDocumentMetadataSerializer_instance;
  function JsonDidDocumentMetadataSerializer_getInstance() {
    if (JsonDidDocumentMetadataSerializer_instance == null)
      new JsonDidDocumentMetadataSerializer();
    return JsonDidDocumentMetadataSerializer_instance;
  }
  function JsonDidResolutionMetadataSerializer() {
    JsonDidResolutionMetadataSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_5);
  }
  var JsonDidResolutionMetadataSerializer_instance;
  function JsonDidResolutionMetadataSerializer_getInstance() {
    if (JsonDidResolutionMetadataSerializer_instance == null)
      new JsonDidResolutionMetadataSerializer();
    return JsonDidResolutionMetadataSerializer_instance;
  }
  //region block: post-declaration
  protoOf(JsonPublicKeyJwk).f2 = get_keys;
  protoOf(JsonPublicKeyJwk).vl = get;
  protoOf(JsonPublicKeyJwk).xl = toMap_0;
  protoOf(JsonPublicKeyJwk).a27 = toJson;
  protoOf($serializer).mz = typeParametersSerializers;
  protoOf($serializer_0).mz = typeParametersSerializers;
  protoOf(JsonDidDocument).f2 = get_keys;
  protoOf(JsonDidDocument).vl = get;
  protoOf(JsonDidDocument).xl = toMap_0;
  protoOf(JsonDidDocument).a27 = toJson;
  protoOf($serializer_1).mz = typeParametersSerializers;
  protoOf(JsonVerificationMethod).f2 = get_keys;
  protoOf(JsonVerificationMethod).vl = get;
  protoOf(JsonVerificationMethod).a27 = toJson;
  protoOf(JsonVerificationMethod).xl = toMap_0;
  protoOf(JsonDidDocumentMetadata).f2 = get_keys;
  protoOf(JsonDidDocumentMetadata).vl = get;
  protoOf(JsonDidDocumentMetadata).xl = toMap_0;
  protoOf(JsonDidDocumentMetadata).a27 = toJson;
  protoOf(JsonDidResolutionMetadata).f2 = get_keys;
  protoOf(JsonDidResolutionMetadata).vl = get;
  protoOf(JsonDidResolutionMetadata).xl = toMap_0;
  protoOf(JsonDidResolutionMetadata).a27 = toJson;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion();
  Companion_instance_1 = new Companion_0();
  Companion_instance_4 = new Companion_3();
  Companion_instance_5 = new Companion_4();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_instance_0;
  _.$_$.b = JsonDidDocument;
  _.$_$.c = JsonDidResolutionSuccessResult;
  _.$_$.d = JsonPublicKeyJwk;
  _.$_$.e = JsonVerificationMethod;
  //endregion
  return _;
}));

//# sourceMappingURL=curity-ssi-libs-did-json.js.map
